module.exports = __webpack_public_path__ + "img/koedboller_bradepande.7500f42a.jpg";